/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Org_Kpi_Ai_Cost_Badge_BillInputs */



/**
* | output |
* | --- |
* | "{count} requests in this bill's period" |
*
* @param {Partner_Org_Kpi_Ai_Cost_Badge_BillInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_kpi_ai_cost_badge_bill = /** @type {((inputs: Partner_Org_Kpi_Ai_Cost_Badge_BillInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Kpi_Ai_Cost_Badge_BillInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Anfragen im Zeitraum dieser Rechnung`)
	return /** @type {LocalizedString} */ (`${i?.count} requests in this bill's period`)
});